import LoadingSpinnerBox from '@/components/loading-spinner-box';
import useAutoRefreshToken from '@/modules/auth/hooks/useAutoRefreshToken';
import type { AuthUserStoreState } from '@/modules/auth/stores/useAuthUserStore';
import useAdminSettingsQuery from '@/modules/core/queries/useAdminSettingsQuery';
import { GlobalRouteSearchParamSchema } from '@/modules/core/types/GlobalRouteSearch';
import type { BaseError } from '@/modules/errors/constants/error-class-map.gen';
import { TanstackDevtools } from '@tanstack/react-devtools';
import { FormDevtools } from '@tanstack/react-form-devtools';
import type { QueryClient } from '@tanstack/react-query';
import { ReactQueryDevtoolsPanel } from '@tanstack/react-query-devtools';
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import { TanStackRouterDevtoolsPanel } from '@tanstack/react-router-devtools';

function RootComponent() {
  const { isLoading } = useAdminSettingsQuery({ enabled: true });
  // listen for token expiration and refresh the token if needed
  useAutoRefreshToken();

  return (
    <>
      {isLoading ? <LoadingSpinnerBox key="root_loading_spinner_box" /> : null}
      {!isLoading ? <Outlet /> : null}
      {!import.meta.env.PROD && !import.meta.env.DEV && (
        <TanstackDevtools
          config={{
            position: 'bottom-left',
            openHotkey: [],
          }}
          plugins={[
            {
              name: 'Tanstack Router',
              render: <TanStackRouterDevtoolsPanel />,
            },
            {
              name: 'Tanstack Query',
              render: <ReactQueryDevtoolsPanel />,
            },
            {
              name: 'Tanstack Form',
              render: <FormDevtools />,
            },
          ]}
        />
      )}
    </>
  );
}

export const Route = createRootRouteWithContext<{
  queryClient: QueryClient;
  userState: AuthUserStoreState;
  authStartupError?: BaseError | undefined | null;
}>()({
  validateSearch: GlobalRouteSearchParamSchema,
  component: RootComponent,
});
